/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
const HOSTING_DOMAINS = [
  'visorcue-entidades.web.app',
  'visorcue-entidades.firebaseapp.com',
  'entidades.visorcue.aidiapp.com',
  'visorcue.aidiapp.com'
];

// El login con redirect solo funciona si authDomain es el mismo origen desde el que se sirve la app.
function resolveAuthDomain(): string {
  const host = window.location.hostname;
  return HOSTING_DOMAINS.includes(host) ? host : 'visorcue-entidades.web.app';
}
export const environment = {
  production: false,
  appBaseUrls: {
    primary: 'https://visorcue-entidades.web.app/',
    secondary: 'https://visorcue-entidades.firebaseapp.com/',
    tertiary: 'https://entidades.visorcue.aidiapp.com/',
    quaternary: 'https://visorcue.aidiapp.com/'
  },
  firebase: {
    apiKey: "AIzaSyAoNlalPFU5wD3_BEjXH_O8hqIHzeWgmAE",
    //authDomain: "visorsigpac-57282.firebaseapp.com",
    authDomain: resolveAuthDomain(),
    databaseURL: "https://visorsigpac-57282.firebaseio.com",
    projectId: "visorsigpac-57282",
    storageBucket: "visorsigpac-57282.appspot.com",
    messagingSenderId: "620850423073",
    appId: "1:620850423073:web:d5f971a23b57b4ca144a60",
    measurementId: "G-M9QYWP9ZYM"
  },
  firebaseFito: {
    apiKey: "AIzaSyBl0iG70dYnyuweCctFMm8kxtAl9gROcmc",
    authDomain: "fitomecum.firebaseapp.com",
    projectId: "fitomecum",
    storageBucket: "fitomecum.appspot.com",
    messagingSenderId: "1070946164602",
    appId: "1:1070946164602:web:8acb3895b10ccc1463c0c3",
    measurementId: "G-K42MECF1B1"
  },
  imageUpload: {
    maxWidth: 400,  // Ancho máximo para redimensionar imágenes subidas
    displayMaxWidth: 300  // Ancho máximo para mostrar imágenes en el editor
  }
};
